import type React from 'react'

import {
  ARCSIcon,
  AlertIcon,
  BackIcon,
  ChevronRightIcon,
  CloseIcon,
  ContactIcon,
  CopyIcon,
  DotsIcon,
  DownloadIcon,
  EmptyIcon,
  ExpandIcon,
  FeatureIcon,
  GearIcon,
  HistoryIcon,
  HomeIcon,
  LogoutIcon,
  MailIcon,
  NotificationIcon,
  QRIcon,
  QuestionIcon,
  ScanIcon,
  SendIcon,
  SettingsIcon,
  ShareIcon,
  StoreIcon,
  type SvgIconProps,
  VerticalDotsIcon,
} from './SvgIcons'

const ICON_COMPONENTS = {
  Back: BackIcon,
  ChevronRight: ChevronRightIcon,
  Close: CloseIcon,
  Dots: DotsIcon,
  Download: DownloadIcon,
  Expand: ExpandIcon,
  Feature: FeatureIcon,
  Gear: GearIcon,
  History: HistoryIcon,
  Home: HomeIcon,
  Arcs: ARCSIcon,
  Notification: NotificationIcon,
  VerticalDots: VerticalDotsIcon,
  Mail: MailIcon,
  Contact: ContactIcon,
  Logout: LogoutIcon,
  Alert: AlertIcon,
  Empty: EmptyIcon,
  QR: QRIcon,
  Question: QuestionIcon,
  Scan: ScanIcon,
  Send: SendIcon,
  Share: ShareIcon,
  Settings: SettingsIcon,
  Store: StoreIcon,
  Copy: CopyIcon,
} as const

export type IconName = keyof typeof ICON_COMPONENTS

export interface IconProps extends SvgIconProps {
  content?: IconName
}

export const Icon: React.FC<IconProps> = ({ content = 'Back', ...rest }) => {
  const Component = ICON_COMPONENTS[content] ?? BackIcon
  return <Component {...rest} />
}

export default Icon
